<template>
  <div class="card assets-offline-map-local-list">
    <header class="card-header has-background-light">
      <p class="card-header-title has-text-dark">ASSETS LIST</p>
      <div class="buttons">
        <slot name="headerButtons" />
      </div>
    </header>
    <div class="card-content scrollable" :style="{ height: `${height}px` }">
      <slot name="contentTop" />
      <filters :assets="assets" @filter="onFilter" @reset="onFilterReset" />
      <b-table :data="assets" :selected="selected" @select="onSelect">
        <template slot-scope="props">
          <b-table-column field="class" label="CLASS">
            {{ props.row.code ? props.row.code.name : "Unknown" }}
          </b-table-column>
          <b-table-column field="status" label="STATUS">
            {{ props.row.status }}
          </b-table-column>
          <b-table-column field="data" label="DATA">
            <button
              class="button is-outline is-small"
              :title="JSON.stringify(props.row.tags)"
            >
              DATA
            </button>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Filters from "./AssetsOfflineMapLocalListFilters";

export default {
  props: {
    assets: {
      type: Array
    },
    mapHeight: {
      type: Number,
      default: 500
    },
    selected: {
      type: Object
    }
  },
  components: {
    Filters
  },
  computed: {
    height() {
      // Card header height
      return this.mapHeight - 36;
    }
  },
  methods: {
    onSelect(selected) {
      this.$emit("select", selected);
    },
    onFilter(assets) {
      this.$emit("filter", assets);
    },
    onFilterReset() {
      this.$emit("reset");
    }
  }
};
</script>

<style lang="scss">
.assets-offline-map-local-list {
  .card-content {
    // padding: 0;

    .b-table .table {
      border: none;
      th {
        position: sticky;
        top: 0;
        background: white;
        z-index: 1;
      }
    }

    .base-table--pagination {
      padding: 0 10px;
    }

    .filters {
      .card-content {
        padding: 1.5rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AssetsOfflineMapLocalList.vue